module.exports = __webpack_public_path__ + "static/vasano_frame3.79c4fce1.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/animation/vasano_frame3.gif
// module id = ./assets/animation/vasano_frame3.gif
// module chunks = 170844033123148